const firebase = {
  enabled: false
};

export default firebase;



// WEBPACK FOOTER //
// ./src/config/firebase.js